import GlobalAlertStore from '../../stores/globalAlertStore';
import { IMainStore } from '../../typings/stores';
import ModalWindow, { IModalWindowProps } from './modalWindow';
import clsx from 'clsx';
import { inject, observer } from 'mobx-react';
import React from 'react';

export interface IGlobalAlertDialogProps {
	alertStore?: GlobalAlertStore;
}

const GlobalAlertDialog: React.FunctionComponent<IGlobalAlertDialogProps> = ({ alertStore }) => {
	const [open, setOpen] = React.useState(!!alertStore.message);
	const closeHandler = () => {
		setOpen(false);
		// clear the state to be able to show errors with the same message
		alertStore.clearState();
	};

	React.useEffect(() => {
		setOpen(!!alertStore.message);
	}, [alertStore.message]);

	const content = <p>{alertStore.message}</p>;
	const actions = [
		<button
			key="close"
			className={clsx('rup-btn rup-btn--lg', { ['rup-btn--error']: alertStore.state === 'error' })}
			type="button"
			onClick={closeHandler}
		>
			{localize('Close')}
		</button>
	];

	const modalWindowProps: IModalWindowProps = {
		title: alertStore.title,
		content,
		actions,
		open,
		closeHandler,
		danger: alertStore.state === 'error'
	};
	return <ModalWindow {...modalWindowProps}></ModalWindow>;
};

export default inject((stores: IMainStore) => ({
	alertStore: stores.globalAlertStore
}))(observer(GlobalAlertDialog));
